import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import upperCase from 'lodash/upperCase';

import {
  editSbatGroupSelectedInterviewbitTestSelector,
  groupContestCourseTypeSelector,
  updateSbatGroupInterviewbitTest,
} from 'features/classCreation';
import DateTimeInput from 'components/DateTimeInput';
import Field from 'components/Field';
import generateTimeStringFromMinutes from 'utils/generateTimeStringFromMinutes';
import Input from 'components/Input';
import SectionHeading from 'components/SectionHeading';
import styles from './InterviewbitTestDetails.module.scss';

function InterviewbitTestDetails() {
  const dispatch = useDispatch();
  const selectedInterviewbitTest = useSelector(
    editSbatGroupSelectedInterviewbitTestSelector
  );
  const groupContestCourseType = useSelector(groupContestCourseTypeSelector);
  const {
    test_id: testId,
    window,
    offset,
    start_time: startTime,
    end_time: endTime,
  } = selectedInterviewbitTest || {};

  const handleOnStartTimeChange = useCallback(
    (dateTime) => {
      dispatch(
        updateSbatGroupInterviewbitTest({
          ...selectedInterviewbitTest,
          start_time: dateTime,
          course_type: groupContestCourseType,
        })
      );
    },
    [dispatch, selectedInterviewbitTest, groupContestCourseType]
  );

  if (selectedInterviewbitTest) {
    return (
      <div className="p-m">
        <SectionHeading
          title={upperCase(selectedInterviewbitTest.title)}
          titleClassName={styles.sectionHeadingTitle}
          className={styles.sectionHeading}
          subtitle="NOTE: There is no Offset required for the Contest"
        />
        <Input
          value={testId}
          disabled
          className={styles.input}
        />
        <div className="row wrap m-t-xs">
          <Field
            label="Window"
            className="m-r-s"
            labelClassName={styles.fieldLabel}
          >
            <Input
              value={generateTimeStringFromMinutes(window)}
              disabled
              className={styles.input}
            />
          </Field>
          <Field
            label="Offset"
            labelClassName={styles.fieldLabel}
          >
            <Input
              value={generateTimeStringFromMinutes(offset)}
              disabled
              className={styles.input}
            />
          </Field>
        </div>
        <Field
          label="Contest Start Date & Time"
          labelClassName={styles.fieldLabel}
        >
          <DateTimeInput
            value={new Date(startTime).getTime()}
            onChange={handleOnStartTimeChange}
          />
        </Field>
        <Field
          label="Contest End Date & Time"
          labelClassName={styles.fieldLabel}
        >
          <DateTimeInput
            value={new Date(endTime).getTime()}
            disabled
          />
        </Field>
      </div>
    );
  }

  return null;
}

export default InterviewbitTestDetails;
